import { createRouter, createWebHistory } from "vue-router";
import Home from "@/pages/Home.vue";
import SeatingPage from "@/pages/SeatingPage.vue";
import GrandstandsPage from "@/pages/GrandstandsPage.vue";
import Club72 from "@/pages/static/Club72.vue";
import CasaTua from "@/pages/static/CasaTua.vue";

const routes = [
  {
    path: "/:purlId?",
    name: "home",
    component: Home,
    props: true,
  },
  {
    path: "/:purlId?/seating-page/:pageId?/",
    name: "seatingPage",
    component: SeatingPage,
    props: true,
  },
  {
    path: "/:purlId?/grandstands-page",
    name: "grandstandsPage",
    component: GrandstandsPage,
    props: true,
  },
  {
    path: "/72-club",
    name: "72Club",
    component: Club72,
    props: true,
  },
  {
    path: "/casa-tua",
    name: "casaTua",
    component: CasaTua,
    props: true,
  },
  // {
  //   path: "/:purlId?/summary",
  //   name: "summary",
  //   component: () => import("@/pages/Summary.vue"),
  // },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_SUB_FOLDER),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      const hashSection = document.querySelector(to.hash);
      if (hashSection) {
        return window.scrollTo({
          top: document.querySelector(to.hash).offsetTop,
          behavior: "smooth",
        });
      }
    } else {
      // return { left: 0, top: 0 };
    }
  },
});

export default router;
